var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUploadIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 23H1v-7h7.241c.297 2.301 2.312 4.083 4.759 4.083 2.447 0 4.462-1.782 4.759-4.083H25v7zm.933-8.437.005-.003-5.91-12.222-.004.003A.585.585 0 0 0 19.5 2h-.59a.601.601 0 0 0-.592.611.6.6 0 0 0 .591.611h.226l5.318 11h-7.317a.6.6 0 0 0-.59.611c0 2.026-1.588 3.667-3.546 3.667-1.958 0-3.545-1.641-3.545-3.667a.6.6 0 0 0-.591-.61H1.547l5.318-11h.226a.6.6 0 0 0 .59-.612.601.601 0 0 0-.59-.611H6.5a.584.584 0 0 0-.523.341l-.006-.003L.062 14.56l.006.003a.61.61 0 0 0-.068.27v8.556A.6.6 0 0 0 .59 24h24.82a.6.6 0 0 0 .59-.611v-8.556a.617.617 0 0 0-.067-.27zM9.57 4.667c.158 0 .301-.065.404-.171L12.43 1.99v11.426c0 .322.255.583.571.583.316 0 .571-.26.571-.583V1.99l2.454 2.505c.103.106.246.17.404.17.316 0 .571-.26.571-.583a.589.589 0 0 0-.167-.412L13.404.17a.564.564 0 0 0-.808 0l-3.429 3.5A.589.589 0 0 0 9 4.083c0 .323.255.584.571.584z",
    fill: "#3285C2",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/uploadIcon.cfe67449.svg";
export { ForwardRef as ReactComponent };